import { type Doctype } from '@ifixit/helpers';
import { getSearchUrl } from '../../utils';
import { useTranslations } from '@ifixit/i18n';

/**
 * "See all" link component
 */
function SeeAllLink({
   query,
   doctype,
   totalHits,
   localeCode,
}: {
   query: string;
   doctype: Doctype;
   totalHits: number;
   localeCode: string;
}) {
   const t = useTranslations('Search.actions');
   const formattedNumber = Intl.NumberFormat(localeCode, { notation: 'compact' }).format(totalHits);
   return (
      <a
         href={getSearchUrl({ searchStr: query, doctype })}
         className="text-[#0071ce] text-sm font-[510] flex items-center hover:text-brand-700"
      >
         {t('seeAllNumber', {
            number: formattedNumber,
         })}
      </a>
   );
}

/**
 * Section header component with title and "See all" link
 */
export function SectionHeader({
   title,
   query,
   doctype,
   totalHits,
   localeCode,
}: {
   title: string;
   query: string;
   doctype: Doctype;
   totalHits: number;
   localeCode: string;
}) {
   return (
      <div className="flex justify-between items-center w-full mt-2.5 sm:mt-5 mb-2 sm:mb-3 px-4">
         <div className="text-[#11161a] text-md font-[590]">{title}</div>
         <SeeAllLink
            query={query}
            doctype={doctype}
            totalHits={totalHits}
            localeCode={localeCode}
         />
      </div>
   );
}
